import projectsService from '@/services/projectsService.js';
import goalsService from '@/services/goalsService.js'; // Ensure you have this service

export default {
  // No namespacing as per your preference
  state: () => ({
    projects: [],
    openSections: {},      // Tracks open/closed state for each project
    selectedProject: null, // Currently selected project
    showProjectModal: false,
    editingProject: {color: "#48B587"},
  }),
  mutations: {
    setProjects(state, projects) {
      state.projects = projects;
    },
    setOpenSections(state, openSections) {
      state.openSections = openSections;
    },
    setSelectedProject(state, project) {
      state.selectedProject = project;
    },
    addProjectToTop(state, project) {
        state.projects.unshift(project); // Adds the project to the beginning of the array
    },
    setShowProjectModal(state,bool){
      state.showProjectModal = bool;
    },
    setEditingProject(state,project){
      state.editingProject = project;
    }
  },
  actions: {
    showProjectModal({commit},{showModal,editingProject}){
      commit('setShowProjectModal', showModal)
      commit('setEditingProject', editingProject)

    },
    // Unified Action: getUserProjects
    async fetchProjects({ commit, state }) {

      try {
        // 1. Fetch Projects
        const projects = await projectsService.getExistingProjects();
        commit('setProjects', projects);

        if(!projects.length){
          return;
        }
        // 2. Initialize openSections: all sections open
        const openSections = projects.reduce((acc, _, index) => {
          acc[index] = true; // Set each section to open
          return acc;
        }, {});
        commit('setOpenSections', openSections);

        if (!state.selectedProject && projects.length > 0) {
          commit('setSelectedProject', projects[0]);
        }
        const userGoals = await goalsService.getPreviousGoals(state.selectedProject.id); // Implement this service method
        commit('setGoals', userGoals);
      } catch (error) {
        console.error('Error in getUserProjects action:', error);
        // Optionally, handle the error (e.g., commit an error state)
      }
    },
    async editProject({commit, dispatch}, editingProject){
        try {
            // 1. Fetch Projects
            let editedProject = await projectsService.editProject(editingProject);
            console.log('wagwan');
            console.log(editedProject)
            if(editingProject){
                commit('setSelectedProject', editedProject);
                if(!editingProject.id){
                    commit('addProjectToTop', editedProject);
                }
                commit('setShowProjectModal', false)
                await dispatch('fetchProjects');
            }

          } catch (error) {
            console.error('Error in edit project action:', error);
            // Optionally, handle the error (e.g., commit an error state)
          }
    },
    async selectProject({commit,state}, project){
        try {
            commit('setSelectedProject', project);
            const userGoals = await goalsService.getPreviousGoals(state.selectedProject.id); // Implement this service method
            commit('setGoals', userGoals);
          } catch (error) {
            console.error('Error in selecting project', error);
            // Optionally, handle the error (e.g., commit an error state)
          }
    },
    

  },
  getters: {
    projects(state) {
      return state.projects;
    },
    openSections(state) {
      return state.openSections;
    },
    selectedProject(state) {
      return state.selectedProject;
    },
    showProjectModal(state) {
      return state.showProjectModal;
    },
    editingProject(state) {
      return state.editingProject;
    },
  },
};
